module.exports = __webpack_public_path__ + "assets/signalfxicon@2x.png";